<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "VrstaTeme2Base"
};
</script>

<style scoped>

</style>
